import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table view for balance adjustments.
 * @extends JetView
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'Report/GetLoyaltyPlayers'; // API endpoint for loyalty players
        var filter; // Variable to hold filter data

        // Event listener for filtering the table
        this.on(this.app, 'filter:table', (data) => {
            filter = data; // Store the filter data
        });

        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable', // Data table view
                            id: 'datatable', // Unique identifier for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'detailTittle',
                                    header: "<span placeholder='Aprobar' class='webix_icon wxi-close paycheck'></span>", // Header with icon
                                    width: 50,
                                    height: 25,
                                    template: function (obj) {
                                        return ''; // Template for the column
                                    },
                                },
                                {
                                    id: 'ch1',
                                    header: { content: 'masterCheckbox' }, // Header for master checkbox
                                    checkValue: 'on', // Value when checked
                                    uncheckValue: 'off', // Value when unchecked
                                    width: 40,
                                    hidden: !devConfig.getPermAction('changeStateGiftAll', 'Edit'), // Conditional visibility based on permissions
                                    css: 'prm-changeStateGiftAll', // CSS class for styling
                                    template: function (obj, type, value) {
                                        // Template for checkbox rendering
                                        if (
                                            (obj.ResultTypeId == 4 && obj.TypeAward == 1) ||
                                            (obj.ResultTypeId == 4 && obj.TypeAward == 0 && obj.WayToPay == 3)
                                        ) {
                                            if (value == 'on') {
                                                return (
                                                    `<input value=` +
                                                    obj.Id +
                                                    ` class="webix_table_checkbox" type="checkbox" checked="true">`
                                                ); // Render checked checkbox
                                            } else {
                                                return (
                                                    `<input value=` +
                                                    obj.Id +
                                                    ` class="webix_table_checkbox" type="checkbox">`
                                                ); // Render unchecked checkbox
                                            }
                                        } else {
                                            return ``; // No checkbox rendered
                                        }
                                    },
                                },
                                {
                                    id: 'Id',
                                    header: _('ID'), // Localized header
                                    width: 100,
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'GiftId',
                                    header: _('Id Regalo'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'Date',
                                    header: _('Fecha'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'DateModified',
                                    header: _('Fecha Modificó'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'PlayerExternalId',
                                    header: _('Id Usuario'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'CasinoId',
                                    header: _('Id Casino'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                },
                                {
                                    id: 'ResultTypeId',
                                    header: _('Estado'), // Localized header
                                    width: 100,
                                    options: [
                                        { id: '4', value: _('Comprado') }, // Localized option
                                        { id: '5', value: _('Entregado') }, // Localized option
                                    ],
                                },
                                {
                                    id: 'Prize',
                                    header: _('Descripción Premio'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                                {
                                    id: 'TypeAward',
                                    header: _('Tipo Premio'), // Localized header
                                    width: 100,
                                    options: [
                                        { id: '1', value: _('Online') }, // Localized option
                                        { id: '0', value: _('Físico') }, // Localized option
                                    ],
                                },
                                {
                                    id: 'WayToPay',
                                    header: _('Forma Pago'), // Localized header
                                    width: 100,
                                    options: [
                                        { id: '1', value: _('Local Propio') }, // Localized option
                                        { id: '2', value: _('Red Aliada') }, // Localized option
                                        { id: '3', value: _('Domicilio') }, // Localized option
                                    ],
                                },
                                {
                                    id: 'CityBetShop',
                                    header: _('Ciudad'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'BetShopId',
                                    header: _('Id punto de venta'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'BetShop',
                                    header: _('Punto de venta'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'Names',
                                    header: _('Nombres'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'Surnames',
                                    header: _('Apellidos'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'Identification',
                                    header: _('Identificación'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'Phone',
                                    header: _('Teléfono'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'City',
                                    header: _('Ciudad'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'Address',
                                    header: _('Dirección'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'Team',
                                    header: _('Equipo'), // Localized header
                                    width: 100,
                                    sort: 'int',
                                    hidden: true, // Initially hidden
                                },
                                {
                                    id: 'Observation',
                                    header: _('Observación'), // Localized header
                                    width: 150,
                                    sort: 'int',
                                },
                            ],
                            onClick: {
                                /**
                                 * Event handler for clicking on the paycheck icon.
                                 * @param {Object} euv - The event object.
                                 * @param {String} id - The ID of the clicked row.
                                 */
                                paycheck: function (euv, id) {
                                    var gridData = $$('datatable').data.pull; // Get data from the datatable
                                    var size = $$('datatable').getPager().config.size; // Get page size
                                    var page = $$('datatable').getPage(); // Get current page
                                    var first = size * page; // Calculate first index of current page
                                    var last = first + size - 1; // Calculate last index of current page
                                    var arrayCheckeds = []; // Array to hold checked IDs
                                    var gridDataPage = Object.values(gridData).filter(
                                        function (currentValue, index, array) {
                                            return (
                                                index >= first && index <= last // Filter data for current page
                                            );
                                        },
                                    );
                                    gridDataPage.forEach(function (currentValue, index, array) {
                                        if (
                                            (currentValue.ch1 == 'on' &&
                                                currentValue.ResultTypeId == 4 &&
                                                currentValue.TypeAward == 1) ||
                                            (currentValue.ResultTypeId == 4 &&
                                                currentValue.TypeAward == 0 &&
                                                currentValue.WayToPay == 3)
                                        ) {
                                            arrayCheckeds.push(currentValue.Id); // Add checked ID to array
                                        }
                                    });
                                    if (arrayCheckeds.length > 0) {
                                        if (devConfig.getPermAction('changeStateGiftAll', 'Pay')) {
                                            webix
                                                .ui({
                                                    view: 'window', // Create a modal window
                                                    head: _(
                                                        'Desea entregar premios?', // Localized header
                                                    ),
                                                    modal: true,
                                                    position: 'center',
                                                    body: {
                                                        view: 'form',
                                                        id: 'windowTransfersForm', // Unique identifier for the form
                                                        elements: [
                                                            {
                                                                view: 'text',
                                                                label: _(
                                                                    'Observación', // Localized label
                                                                ),
                                                                labelPosition: 'top',
                                                                name: 'Observation', // Name of the input field
                                                                required: true, // Mark as required
                                                            },
                                                            {
                                                                cols: [
                                                                    {
                                                                        view: 'button',
                                                                        value: _(
                                                                            'Cancelar', // Localized button text
                                                                        ),
                                                                        click: function (elementId, event) {
                                                                            this.getTopParentView().hide(); // Hide the modal on cancel
                                                                        },
                                                                    },
                                                                    {
                                                                        view: 'button',
                                                                        value: _(
                                                                            'Aceptar', // Localized button text
                                                                        ),
                                                                        click: function (elementId, event) {
                                                                            var values =
                                                                                $$('windowTransfersForm').getValues(); // Get form values
                                                                            var vthis = this;
                                                                            if (
                                                                                $$('windowTransfersForm').validate() // Validate form
                                                                            ) {
                                                                                let params = {
                                                                                    Ids: arrayCheckeds, // IDs of checked items
                                                                                    State: 'D', // State to change
                                                                                    Observation: values.Observation, // Observation from form
                                                                                };
                                                                                webix
                                                                                    .ajax()
                                                                                    .headers({
                                                                                        'Content-type':
                                                                                            'application/json', // Set content type for AJAX request
                                                                                    })
                                                                                    .post(
                                                                                        devConfig.geturlApi() +
                                                                                            'Report/ChangeStateGiftAll', // API endpoint
                                                                                        params, // Request parameters
                                                                                        {
                                                                                            error: function (
                                                                                                text,
                                                                                                data,
                                                                                                XmlHttpRequest,
                                                                                            ) {
                                                                                                webix.message(
                                                                                                    'Error! ', // Show error message
                                                                                                );
                                                                                            },
                                                                                            success: function (
                                                                                                text,
                                                                                                data,
                                                                                                XmlHttpRequest,
                                                                                            ) {
                                                                                                var resp = JSON.parse(
                                                                                                    text, // Parse response
                                                                                                );
                                                                                                if (
                                                                                                    !resp.HasError // Check for errors in response
                                                                                                ) {
                                                                                                    webix.message(
                                                                                                        _(
                                                                                                            'Premios pagados satisfactoriamente', // Localized success message
                                                                                                        ),
                                                                                                    );
                                                                                                    $$(
                                                                                                        'datatable',
                                                                                                    ).clearAll(); // Clear datatable
                                                                                                    $$(
                                                                                                        'datatable',
                                                                                                    ).load(
                                                                                                        url +
                                                                                                            '?start=0&count=' +
                                                                                                            $$(
                                                                                                                'datatable',
                                                                                                            ).data
                                                                                                                .$pagesize +
                                                                                                            filter, // Reload datatable with new data
                                                                                                    );
                                                                                                    vthis
                                                                                                        .getTopParentView()
                                                                                                        .hide(); // Hide the modal
                                                                                                } else {
                                                                                                    webix.alert({
                                                                                                        type: 'alert-error',
                                                                                                        title: 'Error', // Error title
                                                                                                        text: _(
                                                                                                            'Error! ', // Localized error message
                                                                                                        ),
                                                                                                    });
                                                                                                }
                                                                                            },
                                                                                        },
                                                                                    );
                                                                            } else {
                                                                                webix.message({
                                                                                    title: _(
                                                                                        '¡Error!', // Localized error title
                                                                                    ),
                                                                                    type: 'alert-error',
                                                                                    text: _(
                                                                                        'Completa los campos...', // Localized error message
                                                                                    ),
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                ],
                                                            },
                                                        ],
                                                        elementsConfig: {
                                                            on: {
                                                                onChange: function () {
                                                                    this.validate(); // Validate form on change
                                                                },
                                                            },
                                                        },
                                                    },
                                                    move: true,
                                                })
                                                .show(); // Show the modal
                                        } else {
                                            webix.message({
                                                text: _(
                                                    'No tiene permitido esta acción', // Localized error message
                                                ),
                                                title: _('¡Error!'), // Localized error title
                                                type: 'alert-error',
                                            });
                                        }
                                    } else {
                                        webix.alert({
                                            type: 'alert-error',
                                            title: 'Error', // Error title
                                            text: _(
                                                'Seleccione por lo menos un premio para entregar', // Localized error message
                                            ),
                                        });
                                    }
                                },
                            },
                            on: {
                                /**
                                 * Event handler for before loading data into the datatable.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    ); // Show loading overlay
                                },
                                /**
                                 * Event handler for after loading data into the datatable.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hide loading overlay
                                },
                            },
                            /**
                             * Event handler for when the datatable is ready.
                             */
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') + // Localized no data message
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math calculations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Get the datatable instance
        var url = devConfig.geturlApi() + 'Report/GetLoyaltyPlayers'; // API endpoint for loyalty players

        // Event listener for report filtering
        this.on(this.app, 'report:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // String to hold query parameters

            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'TypeAward') {
                    if (object[i][1] == '1') {
                        grid.hideColumn('WayToPay', { spans: true }); // Hide column based on filter
                    } else {
                        grid.showColumn('WayToPay', { spans: true }); // Show column based on filter
                    }
                }
                if (object[i][0] == 'WayToPay') {
                    if (object[i][1] == '1') {
                        grid.showColumn('CityBetShop', { spans: true });
                        grid.showColumn('BetShop', { spans: true });
                        grid.showColumn('BetShopId', { spans: true });
                        grid.hideColumn('Names', { spans: true });
                        grid.hideColumn('Surnames', { spans: true });
                        grid.hideColumn('Identification', { spans: true });
                        grid.hideColumn('Phone', { spans: true });
                        grid.hideColumn('City', { spans: true });
                        grid.hideColumn('Province', { spans: true });
                        grid.hideColumn('Address', { spans: true });
                        grid.hideColumn('Team', { spans: true });
                    } else {
                        if (object[i][1] == '3') {
                            grid.hideColumn('CityBetShop', { spans: true });
                            grid.hideColumn('BetShop', { spans: true });
                            grid.hideColumn('BetShopId', { spans: true });
                            grid.showColumn('Names', { spans: true });
                            grid.showColumn('Surnames', { spans: true });
                            grid.showColumn('Identification', { spans: true });
                            grid.showColumn('Phone', { spans: true });
                            grid.showColumn('City', { spans: true });
                            grid.showColumn('Province', { spans: true });
                            grid.showColumn('Address', { spans: true });
                            grid.showColumn('Team', { spans: true });
                        } else {
                            grid.hideColumn('CityBetShop', { spans: true });
                            grid.hideColumn('BetShop', { spans: true });
                            grid.hideColumn('BetShopId', { spans: true });
                            grid.hideColumn('Names', { spans: true });
                            grid.hideColumn('Surnames', { spans: true });
                            grid.hideColumn('Identification', { spans: true });
                            grid.hideColumn('Phone', { spans: true });
                            grid.hideColumn('City', { spans: true });
                            grid.hideColumn('Province', { spans: true });
                            grid.hideColumn('Address', { spans: true });
                            grid.hideColumn('Team', { spans: true });
                        }
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        if (object[i][0] == 'DateM') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom2 to query
                            string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo2 to query
                        } else {
                            if (object[i][0] != 'Date') {
                                string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                            } else {
                                if (object[i][0] == 'Date') {
                                    var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                    string1 = string1 + '&dateFrom=' + date; // Add dateFrom to query
                                    string1 = string1 + '&dateTo=' + date; // Add dateTo to query
                                }
                                if (object[i][0] == 'DateM2') {
                                    var date = object[i][1].replace(' 00:00:00', ''); // Clean date string
                                    string1 = string1 + '&dateFrom2=' + date; // Add dateFrom2 to query
                                    string1 = string1 + '&dateTo2=' + date; // Add dateTo2 to query
                                }
                            }
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object from start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object from end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the datatable
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            this.app.callEvent('filter:table', [string1]); // Call filter event
            $$('filterPopup').hide(); // Hide filter popup
        });
    }
}

// FILE DOCUMENTED
